import logo from "../../src/assets/images/logo.png";
import logo_Light from "../../src/assets/images/logo-light.png";
const Header =()=>{
    return (
      <>
        {/* Main Header*/}
        <header className="main-header header-style-one">
          {/* Header Top */}
          <div className="header-top">
            <div className="auto-container">
              <div className="top-left">
                {/* Info List */}
                <ul className="info-list">
                  <li>
                    <i className="fa-solid fa-envelope" />{" "}
                    <a href="mailto:info@paic-sa.com">info@paic-sa.com</a>
                  </li>
                  <li>
                    <i className="fa-solid fa-location-dot" /> Jeddah
                  </li>
                </ul>
              </div>
              <div className="top-right">
                <ul className="useful-links">
                  <li>
                    <a href="/about">About</a>
                  </li>
                  {/* <li>
                    <a href="/faq">Faqs</a>
                  </li> */}
                  <li>
                    <a href="/contact">Contact</a>
                  </li>
                </ul>
                <ul className="top-social-icon">
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-x-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-linkedin-in" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Header Top */}
          {/* Main box */}
          <div className="main-box">
            <div className="logo-box">
              <div className="logo">
                <a href="/">
                  <img src={logo} alt title="Consultez" />
                </a>
              </div>
            </div>
            {/*Nav Box*/}
            <div className="nav-outer">
              <nav className="nav main-menu">
                <ul className="navigation">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/services">Services</a>
                  </li>
                  <li>
                    <a href="/verification">Verification</a>
                  </li>
                  <li>
                    <a href="/team">Team</a>
                  </li>
                  <li>
                    <a href="/clients">Our Clients</a>
                  </li>
                  <li>
                    <a href="/our-projects">Our Projects</a>
                  </li>
                  <li>
                    <a href="/about">About Us</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                </ul>
              </nav>
              {/* Main Menu End*/}
            </div>
            <div className="outer-box">
              <div className="info-box">
                <div className="call-info">
                  <i className="fa-solid fa-phone ring__animation" />
                  <div>
                    <h6 className="title">Phone:</h6>
                    <a href="tel:+966535897085">+966 53 589 7085</a>
                  </div>
                </div>
                <a className="btn-two" href="/contact">
                  Contact Now
                </a>
              </div>
              <div className="mobile-nav-toggler d-block d-lg-none">
                <i className="icon lnr-icon-bars" />
              </div>
              {/* Mobile Nav toggler */}
            </div>
          </div>
          <div className="auto-container">
            {/* Mobile Menu  */}
            <div className="mobile-menu">
              <div className="menu-backdrop" />
              {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
              <nav className="menu-box">
                <div className="upper-box">
                  <div className="nav-logo logo-light">
                    <a href="/">
                      <img src={logo_Light} alt />
                    </a>
                  </div>
                  <div className="close-btn">
                    <i className="icon fa fa-times" />
                  </div>
                </div>
                <ul className="navigation clearfix d-block d-lg-none">
                  {/*Keep This Empty / Menu will come through Javascript*/}
                </ul>
                <div className="content-box d-none d-lg-block">
                  <h4 className="title">About Us</h4>
                  <p className="text">
                    Pak Arab Inspection Limited Company is an independent
                    inspection and technical services provider delivering
                    reliable assessment, quality assurance, and safety solutions
                    across Saudi Arabia. Our services include GEO Technical
                    Investigation, Third Party Vendor Inspection, HSEQ Training
                    Consultancy, Calibration Services, and Civil Testing.
                  </p>
                </div>
                <ul className="contact-list-one">
                  <li>
                    {/* Contact Info Box */}
                    <div className="contact-info-box">
                      <i className="icon lnr-icon-phone-handset" />
                      <span className="title">Call Now</span>
                      <a href="tel:+966535897085">+966 53 589 7085</a>
                    </div>
                  </li>
                  <li>
                    {/* Contact Info Box */}
                    <div className="contact-info-box">
                      <span className="icon lnr-icon-envelope1" />
                      <span className="title">Send Email</span>
                      <a href="mailto:info@paic-sa.com">info@paic-sa.com</a>
                    </div>
                  </li>
                  <li>
                    {/* Contact Info Box */}
                    <div className="contact-info-box">
                      <span className="icon lnr-icon-clock" />
                      <span className="title">Send Email</span>
                      Sun - Thu 8 AM - 6 PM
                    </div>
                  </li>
                </ul>
                <ul className="social-links">
                  <li>
                    <a href="#">
                      <i className="fab fa-x-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-pinterest" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-instagram" />
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            {/* End Mobile Menu */}
            {/* Header Search */}
            <div className="search-popup">
              <span className="search-back-drop" />
              <button className="close-search">
                <span className="fa fa-times" />
              </button>
              <div className="search-inner">
                <form method="post" action="index.html">
                  <div className="form-group">
                    <input
                      type="search"
                      name="search-field"
                      defaultValue
                      placeholder="Search..."
                      required
                    />
                    <button type="submit">
                      <i className="fa fa-search" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/* End Header Search */}
            {/* Sticky Header  */}
            <div className="sticky-header">
              <div className="auto-container">
                <div className="inner-container">
                  {/*Logo*/}
                  <div className="logo">
                    <a href="index.html">
                      <img src={logo} alt />
                    </a>
                  </div>
                  {/*Right Col*/}
                  <div className="nav-outer">
                    {/* Main Menu */}
                    <nav className="main-menu">
                      <div className="navbar-collapse show collapse clearfix">
                        <ul className="navigation clearfix">
                          {/*Keep This Empty / Menu will come through Javascript*/}
                        </ul>
                      </div>
                    </nav>
                    {/* Main Menu End*/}
                    {/*Mobile Navigation Toggler*/}
                    <div className="mobile-nav-toggler">
                      <span className="icon lnr-icon-bars" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Sticky Menu */}
          </div>
        </header>
        {/*End Main Header */}
      </>
    );
}
export default Header;